import styled, { css } from 'styled-components';
import { FlexBoxCol, FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { blockMargin, breakPoints, CSSPropWithBreakpoints, styleWithBreakPoints } from '~/src/components/LandingBlock/styled';
import { IMG_DOMAIN } from '~/src/services/blocks/templates';

export interface IGridStyles {
    Grid: CSSPropWithBreakpoints
    [key: string]: CSSPropWithBreakpoints;
}

interface IGridColumnStyles {
    Image: CSSPropWithBreakpoints;
    Text: CSSPropWithBreakpoints;
}

interface IPadding {
    horizontal?: number;
    vertical?:  number;
}

export const StyledGrid = styled(GridContainer)`
    display: flex;
    max-width: 100%;
    width: 1568px;
    
    @media (max-width: ${breakPoints.wDesktop}) {
        width: 1280px;
    }
    @media (max-width: ${breakPoints.sDesktop}) {
        width: 1000px;
    }
    @media (max-width: ${breakPoints.mobile}) {
        width: 768px;
        padding-left: 16px;
        padding-right: 16px;
    }
    @media (max-width: 767px) {
        width: 100%;
        justify-content: center;
    }
`;

export const Col = styled(FlexBoxCol)`
    margin-bottom: 15px;
    @media (max-width: ${breakPoints.mobile}) {
        padding: 0;
    }
`;

export const Row = styled(FlexBoxRow)`
    width: 100%;
`;

export const ColWrapper = styled.div<{backgroundColor?: string, backgroundImage?: string, borderRadius?: number, padding?: IPadding, imagePlacement?: string}>`
    ${p => p.backgroundImage
        ? css`
            background: url(${IMG_DOMAIN}${p.backgroundImage}) no-repeat center / cover;;
        ` : css`
            background-color: ${p.backgroundColor ?? 'transparent' };
        `
    }
    border-radius: ${p => p.borderRadius ? p.borderRadius + 'px' : '0' };
    padding: ${p => +p.padding?.vertical + 'px ' + +p.padding?.horizontal + 'px'};
    height: 100%;
    display: flex;
    flex-direction: ${p => p.imagePlacement === 'top' ? 'column' : 'row'};
    overflow: hidden;

    @media (max-width: ${breakPoints.mobile}) {
        flex-direction: column;
    }
    
    ${p => styleWithBreakPoints(p, 'BlockGridColumn')};
`;

export const Wrapper = styled.div<IGridStyles>`
    background: ${p => p.background ? `url(${p.background}) no-repeat center / cover` : 'transparent'};
    width: 100%;
    padding: 14px 0 32px;
    
    ${p => blockMargin(p)};    
    ${p => styleWithBreakPoints(p, 'BlockGrid')};
`;

export const Icon = styled.div<IGridColumnStyles>`
    display: flex;
    object-fit: contain;
    
    img {
        width: 100%;
        margin-bottom: -6px;
    }
    
    ${p => styleWithBreakPoints(p, 'Image')};
`;

export const IconWrapper = styled.div`
    display: flex;
`;

export const Title = styled.div<IGridColumnStyles>`
    margin-top: 12px;
    & p {
        margin-bottom: 0;
    }
    ${p => styleWithBreakPoints(p, 'Title')};
`;

export const Text = styled.div<IGridColumnStyles>`
    margin-top: 8px;
    margin-bottom: 24px;
    
    ${p => styleWithBreakPoints(p, 'Text')};
`;

export const Header = styled.div<IGridStyles>`
    margin-top: 0;
    margin-bottom: 32px;
    
    ${p => styleWithBreakPoints(p, 'BlockGrid.Header')};
`;

export const ImageWrapper = styled.div<{ imagePlacement?: string }>`
    display: flex;
    align-items: center;
    order: ${p => p.imagePlacement === 'right' ? '2' : '-1'};
    margin: ${p => p.imagePlacement !== 'top'
        ? p.imagePlacement === 'left' ? '0 10px 0 0' : '0 0 0 10px'
    : 0};
    
    @media (max-width: ${breakPoints.mobile}) {
        order: -1;
        margin: 0px
    }
    
    ${p => styleWithBreakPoints(p, 'Image', 'justify')};
`;

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    order: 1;
`;
